export const name = 'validateInput';

export default function validateInput(Validation, $compile, $log, $timeout, $parse) {

  //noinspection BadExpressionStatementJS
  'ngInject';

  return {
    require: 'ngModel',
    restrict: 'A',
    scope: true,
    priority: 102,
    link: function (scope, element, attrs, ctrl) {
      scope.$watch(function () {
        return  ctrl.$modelValue;
      }, function () {

        var required = isRequired();

        if (!ctrl.$pristine || angular.isDefined(ctrl.$modelValue)) {

          var doValidation = true;
          var deleteNext = false;
          var value = ctrl.$modelValue;
          var propertyName = scope.$eval(attrs.propertyName);
          if(propertyName === undefined) {
            // fallback to the property value as a string
            propertyName = attrs.propertyName;
          }
          var validationLength = {};
          var customValidation = attrs.customValidation;

          if (attrs.ngMaxLength !== undefined) {
            validationLength = attrs.ngMaxLength;
          } else if(attrs.maxLength !== undefined) {
            validationLength = attrs.maxLength;
          }

          if (attrs.validateIfDirty !== undefined && ctrl.$pristine){
            doValidation = false;
          }

          if (attrs.doValidation !== undefined) {
            doValidation = attrs.doValidation;
          }

          var disabled = attrs.disabled;
          if (disabled !== undefined && disabled !== null && disabled === true) {
            doValidation = false;
          }


          if (doValidation) {
            var promise = Validation.validate(required, propertyName, value, validationLength, customValidation);
            promise.then(function (validationResult) {
              setValidity('required1', validationResult.required);
              setValidity('valid', validationResult.valid);
              setValidity('length', validationResult.length);
              setValidity('max', validationResult.max);
              setValidity('validInput', true);
            }, function () {
              resetValidity();
            });

          } else {
            resetValidity();
          }
        }
        else {
          resetValidity();
          if(required ){
            ctrl.$setValidity('validInput', false);
          }else{
            ctrl.$setValidity('validInput', true);
          }
        }

      });

      scope.$watch( attrs.ngRequired, function () {
        var required = false;
        if (attrs.ngRequired) {
          required = $parse(attrs.ngRequired)(scope);
          if(required && ctrl.$pristine &&  !(angular.isDefined(ctrl.$modelValue))){
            ctrl.$setValidity('validInput', false);
          }
          else if (ctrl.$pristine && !(angular.isDefined(ctrl.$modelValue))) {
            ctrl.$setValidity('validInput', true);
          }
        }
      }, true);

      appendValidationMessages();

      /**
       * Returns the form element associated with a specific element by traversing up the DOM from the element's position
       * and returns the first form element it comes across.
       * @param element The element from which to begin the traversal
       * @returns {*}
       */
      function getForm(element) {
        try {
          var parent = element.parent();
          while (parent[0].tagName.toLowerCase() !== 'form') {
            parent = parent.parent();
          }
          return parent;
        }
        catch (exception) {
          return null;
        }
      }

      function setValidity(name, value) {
        if(value === false) {
          ctrl.$setValidity(name, false);
        } else {
          ctrl.$setValidity(name, true);
        }
      }

      function resetValidity() {
        ctrl.$setValidity('length', true);
        ctrl.$setValidity('max', true);
        ctrl.$setValidity('valid', true);
        ctrl.$setValidity('required1', true);
        ctrl.$setValidity('validInput', true);
      }

      /**
       * Determines whether the form element has required input. Looks for the angular ngRequired input attribute first.
       * If that is not found it looks for the HTML5 required atttribute. If that's not found either, it returns false.
       */
      function isRequired() {
        let required = false;

        try {
          // Angular version
          if (attrs.ngRequired !== undefined) {
            if (typeof attrs.ngRequired === 'boolean') {
              required = attrs.ngRequired;
            } else if (typeof attrs.ngRequired === 'string') {
              let requiredStr = attrs.ngRequired;
              if (requiredStr.toLowerCase() === 'true' || requiredStr.toLowerCase() === 'false') {
                required = Boolean(requiredStr.toLowerCase());
              }
              else {
                required = $parse(requiredStr)(scope);
              }
            }
          }
          // HTML5 version
          else if (attrs.required !== undefined) {
            required = attrs.required;
          }
        }
        catch (Exception) {
          $log.error('Unable to parse required attribute');
        }

        return required;
      }

      /**
       * Creates and appends the ng-messages div to the current form, if found. Else, does nothing.
       */
      function appendValidationMessages() {
        let formElement = getForm(element);
        let messagesFor = formElement.attr("name") + '.' + attrs.name + '.$error';

        let parent = element.parent();
        let ngMessagesElement = parent[0].querySelector('[ng-messages],ng-messages');
        if(ngMessagesElement) {
          ngMessagesElement = angular.element(ngMessagesElement);
        } else {
          ngMessagesElement = angular.element("<div ng-messages='" + messagesFor + "'>");
          parent.append(ngMessagesElement);
        }
        let messagesToAppend = angular.element(
          "<div ng-message='required1'><translate>uxf.uxf.Validation_Required</translate></div>" +
          "<div ng-message='valid'><translate>uxf.uxf.Validation_Invalid</translate></div>" +
          "<div ng-message='length'><translate>uxf.uxf.Validation_Length</translate></div>" +
          "<div ng-message='max'><translate>uxf.uxf.Validation_Max</translate></div>"
        );

        ngMessagesElement.append(messagesToAppend);
        $compile(ngMessagesElement)(scope);
      }
    }
  };
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/validation/validateInput.directive.js